<script>
    import Fa from 'svelte-fa';
    import { faChevronRight, faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

    import Picture from '$lib/components/Picture.svelte';

    export let drawerOpen;
    export let data;

    let openDrawerId;
</script>

<div role="menu" aria-label="Main Menu">
    {#each data as item (item)}
        <!-- Direct Link -->
        {#if !item?.menuItems && item?.url}
            <a
                class="flex w-full items-center border-b border-color-text/10 px-8 py-4 text-left"
                href={item?.url}
                title={item?.title}
                role="menuitem"
                on:click={() => (drawerOpen = false)}
            >
                {#if item?.image?.url}
                    <Picture
                        src={item?.image?.url}
                        alt={`Icon of ${item?.title}`}
                        width="30"
                        height="30"
                        imageSizes={[30, 30, 30]}
                        lazy={true}
                        classes="inline-block -ml-2 mr-2 w-8.5"
                    />
                {/if}
                <span class="inline-block text-base">{item?.title}</span>
            </a>

            <!-- Title Section Break -->
        {:else if !item?.menuItems && item?._type === 'linkTitle'}
            <div class="mt-6 p-2 pb-0" role="none">
                <span class="px-2 text-left text-base font-semibold dark:text-purple-300">{item?.title}</span>
            </div>

            <!-- Image Banner / Link -->
        {:else if !item?.menuItems && item?._type === 'imageLink'}
            <div class="p-2 pb-0" role="none">
                <a href={item?.link?.url || '/'} on:click={() => (drawerOpen = false)} title={item?.alt} role="menuitem">
                    <Picture
                        src={item?.image?.url}
                        alt={item?.alt}
                        width={item?.image?.dimensions?.width}
                        height={item?.image?.dimensions?.height}
                        imageSizes={[350, 400, 400]}
                        lazy={true}
                        classes="rounded-br-2xl rounded-tl-2xl w-full"
                    />
                </a>
            </div>

            <!-- Another Submenu level -->
        {:else if item?.menuItems}
            <button
                class="w-full border-b border-color-text/10 py-4 pl-8 pr-6 text-left text-base lg:pr-8"
                role="menuitem"
                on:click={() => {
                    openDrawerId = item._key;
                }}
            >
                <div class="grid grid-cols-2 items-center">
                    <div class="flex items-center">
                        {#if item?.image?.url}
                            <Picture
                                src={item?.image?.url}
                                alt={`Icon of ${item?.title}`}
                                width="30"
                                height="30"
                                imageSizes={[30, 30, 30]}
                                lazy={true}
                                classes="inline-block -ml-2 mr-2 w-full w-8.5"
                            />
                        {/if}
                        <span class="inline-block">{item?.title}</span>
                    </div>
                    <div class="text-right">
                        <Fa icon={faChevronRight} class="inline-block" />
                    </div>
                </div>
            </button>
            <div
                class={`no-scrollbar delay-800 absolute top-0 h-screen w-full list-none overflow-x-hidden overflow-y-scroll bg-color-background pb-60 transition-all ease-in-out dark:bg-base-900
                        ${openDrawerId === item._key ? 'visible right-0 opacity-100' : 'invisible -right-full opacity-0'}`}
            >
                <div class="py-4 pb-2">
                    <button
                        class="px-4"
                        on:click={() => {
                            openDrawerId = null;
                        }}
                        role="menuitem"
                        ><Fa icon={faArrowLeft} class="inline-block" />
                    </button>
                    <div class="inline-block text-left text-xl font-semibold dark:text-purple-300">{item?.title}</div>
                </div>
                <svelte:self data={item?.menuItems} bind:drawerOpen />
            </div>
        {/if}
    {/each}
</div>
